import React, { FC } from 'react';
import { formatCurrency } from '@/pages/table/utils/utils';

const LegendLabel = ({
  value,
  shouldDisplayInBB,
  bigBlindValue,
}: {
  value: number;
  shouldDisplayInBB: boolean;
  bigBlindValue: number;
}) => {
  const formattedValue = shouldDisplayInBB
    ? `${(value / bigBlindValue).toFixed(2)} BB`
    : formatCurrency(parseFloat(value.toFixed(2)));

  return <span className="text-[0.625em] font-bold text-white">{formattedValue}</span>;
};

const Dot = () => <span className="h-1.5 w-1.5 rounded-full bg-white opacity-30" />;

interface BetSliderLegendProps {
  max: number;
  min: number;
  shouldDisplayInBB: boolean;
  bigBlindValue: number;
}

const BetSliderLegend: FC<BetSliderLegendProps> = ({ max, min, shouldDisplayInBB, bigBlindValue }) => {
  const labelsCount = 4;
  const step = Math.floor((max - min) / (labelsCount - 1));
  const valuesArray = Array.from(new Set([max, max - step, max - 2 * step, min]));

  return (
    <div className="flex h-[13.375em] flex-col justify-between gap-3.5">
      {valuesArray.map((value, index) => (
        <React.Fragment key={value}>
          <LegendLabel value={value} shouldDisplayInBB={shouldDisplayInBB} bigBlindValue={bigBlindValue} />
          {index !== valuesArray.length - 1 && (
            <>
              <Dot />
              <Dot />
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default BetSliderLegend;
